<mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>

<div mat-dialog-content>
  <h1 mat-dialog-title>Add Role</h1>
  <form [formGroup]="registerForm" (ngSubmit)="register()">
    <!-- Role Name Field -->
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Role Name</mat-label>
      <input matInput formControlName="role" type="text" />
      <mat-error *ngIf="registerForm.get('role')?.hasError('required')">
        Role name is required.
      </mat-error>
    </mat-form-field>

    <!-- IsAdmin Checkbox -->
    <mat-checkbox formControlName="isAdmin">Is Admin</mat-checkbox>

    <!-- Buttons -->
    <div class="button-group">
      <button mat-raised-button color="primary" type="submit" [disabled]="isLoading">Add</button>
      <button mat-button color="warn" (click)="onCancel()">Cancel</button>
    </div>
  </form>
</div>
